import axios from "axios";
import { endpoints, getPath } from "./apiUtils";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AuthContext } from "../useAuth";
import { useContext } from "react";

const listSessions = async (userId, token, queryParams) => {
  let path = getPath({
    endpoint: endpoints.users,
    path: [userId, "sessions"],
    queryParameters: queryParams,
  });
  return axios
    .get(path, { headers: { Authorization: token } })
    .then((r) => r.data);
};

const getSession = async (sessionId, token) => {
  let path = getPath({
    endpoint: endpoints.sessions,
    path: [sessionId],
  });
  return axios
    .get(path, { headers: { Authorization: token } })
    .then((r) => r.data);
};

export const useSessions = (userId, queryParams) => {
  const { getAccessToken } = useContext(AuthContext);

  return useQuery({
    queryKey: ["sessions", userId],
    queryFn: async () =>
      listSessions(userId, await getAccessToken(), queryParams),
    enabled: !!userId,
  });
};

export const useSession = (sessionId, userId) => {
  const { getAccessToken } = useContext(AuthContext);
  let path = getPath({
    endpoint: endpoints.sessions,
    path: [sessionId],
  });
  return useQuery({
    queryKey: ["session", sessionId],
    queryFn: async () => getSession(sessionId, await getAccessToken()),
    enabled: !!sessionId && !!userId,
  });
};

export const useSessionMutation = () => {
  const { getAccessToken } = useContext(AuthContext);
  let path = getPath({
    endpoint: endpoints.sessions,
  });

  return useMutation({
    mutationFn: async (data) =>
      axios
        .post(path, data, {
          headers: { Authorization: await getAccessToken() },
        })
        .then((r) => r.data),
  });
};

export const useSessionAccept = (userId, sessionId) => {
  const { getAccessToken } = useContext(AuthContext);

  let path = getPath({
    endpoint: endpoints.sessions,
    path: [sessionId, "accept"],
  });

  const queryClient = useQueryClient();

  return useMutation(
    async () =>
      axios
        .put(
          path,
          { UserId: userId },
          { headers: { Authorization: await getAccessToken() } }
        )
        .then((r) => r.data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["sessions"]);
      },
    }
  );

  // return (
  //   useMutation(async () =>
  //     axios
  //       .put(
  //         path,
  //         { UserId: userId },
  //         { headers: { Authorization: await getAccessToken() } }
  //       )
  //       .then((r) => r.data)
  //   ),
  //   {
  //     enabled: !!sessionId && !!userId,
  //     onSuccess: () => {
  //       queryClient.invalidateQueries("sessions");
  //     },
  //   }
  // );
};

export const useSessionDelete = (sessionId) => {
  const { getAccessToken, user } = useContext(AuthContext);
  let path = getPath({
    endpoint: endpoints.sessions,
    path: [sessionId, "cancel"],
  });

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () =>
      axios
        .request({
          url: path,
          method: "DELETE",
          headers: { Authorization: await getAccessToken() },
          data: { UserId: user.UserId, OrganizationId: user.OrganizationId },
        })
        .then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries(["sessions"]);
    },
  });
};
